import { InterestedDealers } from "../../../services/oem-dealer.service";

import { OemDealerService } from "src/app/shared/services/oem-dealer.service";
import { Vehicle } from "../../../model/vehicle";
import { Component, Input, OnInit } from "@angular/core";
import { FileUtils } from "@app-utils/file-utils";
import { EvaluationVehicle, FastQuote } from "@app-model/evaluation";
import { d } from "@datorama/akita-ngdevtools";
import * as moment from "moment";

@Component({
  selector: "app-card-interested-dealers",
  templateUrl: "./card-interested-dealers.component.html",
  styleUrls: ["./card-interested-dealers.component.scss"],
})
export class CardInterestedDealersComponent implements OnInit {
  @Input() vehicle: Vehicle | EvaluationVehicle;
  @Input() fastQuote: FastQuote;

  dealers: InterestedDealers[] = [];

  showDealers = false;

  loading = false;

  constructor(private oemDealerService: OemDealerService) { }

  ngOnInit() {

  }

  private isVehicleInFastQuote(): boolean {
    const evalVehicle = this.vehicle as EvaluationVehicle;
    if (evalVehicle.inFastQuote !== undefined) {
      return !!evalVehicle.inFastQuote;
    }
    return this.vehicle.status === 'FAST_QUOTE' || this.vehicle.status === 'FAST_QUOTE_WITH_OFFER';
  }

  loadDealers() {
    this.loading = true;
    let id;
    const isFastQuote = this.fastQuote !== undefined && this.isVehicleInFastQuote();
    if (isFastQuote) {
      id = this.vehicle.fastQuoteId;
    } else {
      id = this.vehicle.id;
    }
    this.oemDealerService
      .getInterestedDealers(id, isFastQuote)
      .subscribe((resp) => {
        this.dealers = resp;
        this.loading = false;
      }, err => {
        this.loading = false;
      });
  }
   

  downloadDealersInfo() {
    let id;
    const isFastQuote = this.fastQuote !== undefined && this.isVehicleInFastQuote();
    if (isFastQuote) {
      id = this.vehicle.fastQuoteId;
    } else {
      id = this.vehicle.id;
    }
    this.oemDealerService
      .downloadInterestedDealersInfo(id, isFastQuote)
      .subscribe(blob => {
        FileUtils.saveBlobAsFile(`Relatório de acessos ${isFastQuote ? '- cotação rápida ' : ''}- ${this.vehicle.makeName} ${this.vehicle.modelName} ${this.vehicle.modelYear} - ${this.vehicle.numberPlate}.csv`, blob);
      });
  }

  getVehicleTypeStr(): string {
    if (this.fastQuote !== undefined && moment(this.fastQuote.expiration) > moment(new Date())) {
      return 'na cotação rápida';
    } else {
      return 'no repasse';
    }
  }
}
